// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3NWfn","col":"styles_col__1WCIw"};